/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, { useContext, useState } from "react";

import { useDispatch } from "react-redux";
import useTypedSelector from "@Services/Hooks/UseTypedSelector";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import { Col } from "react-bootstrap";

import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";

import { BHPCOURSE_INTERFACE } from "@Services/Application/Interfaces/Users/User";

import { Row } from "react-bootstrap";
import { APPLICATION_ROUTER_INTERFACE } from "@DATA/Router/Interfaces/Router";
import { ApplicationRouterContext } from "@Contexts/Router";
import ExtraLinkComponent from "./ExtraLink";
import QuizNextButtonComponent from "../QuizNextButton";

import ENV from "react-dotenv";
import SessionExtendComponent from "../SessionExtend";

type BhpQuizExtraLinksPageProps = { match?: any; location?: any; };

export const BhpQuizExtraLinksPageComponent: React.FC<BhpQuizExtraLinksPageProps> = ({
    match, location
}): JSX.Element | null => {

    const BHPCOURSE: BHPCOURSE_INTERFACE = location?.state?.bhpCourse;
    const TERMINAL_NO : string = location?.state?.terminalNo;

    const DISPATCHER = useDispatch();

    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;

    /** @const {object} INTERFACE_DATA - Application State Store Interface Data */
    const INTERFACE_DATA: ReturnType<any> = useTypedSelector(
        (state) => state.interface
    );

    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);
    const QUIZROUTE = ROUTER.AUTHENTICATED.SETTINGS.SETTINGS_MY_BHP_PAGE.QUIZ;

    var playersEnded: Boolean[] = [];

    BHPCOURSE.ExtraLinks?.map((link, index) => (
        playersEnded[index]=false
    ))

    const [PlayersEnded, setPlayersEnded] = useState(playersEnded);
    
    const onPlayerEnded = (index:number) => {
        let players = JSON.parse(JSON.stringify(PlayersEnded));
        players[index]= true;
        setPlayersEnded(players);
    }

    if (!LOGGED_USER || !LOGGED_USER?.userID) return null;

    return (
        <BlockContentContainerComponent cssClasses={"settings-page-user-data-component settings-page-view-component"}>

            <BlockContentHeaderComponent headerText={"Szkolenie BHP"} />

            {!!BHPCOURSE ?

                <Col xs={12} className={"user-profile-data user-information-data"}>
                    <SessionExtendComponent SESSIONMAXTIMESECONDS={3600}/>
                    <Row className={"user-profile-data-content"}>                        
                        <div style={{ minHeight: "64vh", width: "100%" }}>
                            <Col xs={12} className={"user-information-section-component user-information-section user-document-data"}>
                                <Row className={"user-information-section-content"}>
                                    <Col xs={12} className={"user-information-data user-important-information user-name"}>
                                        <span>{`Film instruktażowy`}</span>
                                    </Col>
                                </Row>

                                <Row className={"user-information-section-content"} style={{ marginTop: 40, marginBottom: 40 }}>
                                    <Col xs={12} className={"user-information-data text-center"}>
                                        {BHPCOURSE.ExtraLinks?.map((link, index) => (
                                            <ExtraLinkComponent LINK={link.ExtraLink} INDEX={index} ONENDED={onPlayerEnded} />
                                        ))}
                                    </Col>
                                </Row>
                            </Col>
                        </div>

                        <Col xs={12} style={{ marginTop: 30, textAlign: "center" }}>
                            <QuizNextButtonComponent
                                TO={{ pathname: QUIZROUTE.QUIZQUASTION.URL, state: { bhpCourse: BHPCOURSE, quastionNo: 0, terminalNo: TERMINAL_NO } }}
                                TITLE="Dalej"
                                DISABLED={!PlayersEnded.every(value=> value==true) && ENV?.APP_bhp_quiz_allow_start_without_film !== "true" }
                            />
                        </Col>

                    </Row>
                </Col>

                :

                <Col xs={12} className={"no-list-elements-message default-system-message"}>
                    <span>{`Brak informacji o kursie. Spróbuj ponownie później.`}</span>
                </Col>
            }
        </BlockContentContainerComponent>
    );

};


export default BhpQuizExtraLinksPageComponent;
